import React from 'react';
import { Link } from 'react-router-dom';
import { environments } from 'environments/environments';
import { Event } from '../../Event.interface';
import './NearestEvent.css';

const NearestEvent = (props: { event: Event }) => {
  function makeEventName() {
    const event = props.event;
    let renderName = event.name || 'Doktor Triceratops';
    if (!event.name && (event.place || event.location)) {
      if (event.place && event.location) {
        renderName += ` - ${event.place} (${event.location})`;
      } else {
        renderName += ' - ' + (event.place || event.location);
      }
    }
    return renderName;
  }

  const event = props.event;
  const renderDate = `${event.day}. ${event.month}. ${event.year}`;
  const eventName = makeEventName()
  const renderLocation = event.location && event.place ? `${event.place} (${event.location})` : '';
  const renderPoster = event.poster ? <img src={`${environments.server}${event.poster}`} alt={`${eventName}`} /> : null;
  const linkName = event.name && event.name.normalize('NFKD').replace(/[^\w]/g, '-');
  const months = [
    "Leden", "Únor", "Březen",
    "Duben", "Květen", "Červen",
    "Červenec", "Srpen", "Září",
    "Říjen", "Listopad", "Prosinec"
  ];
  const renderMonth = months[event.month - 1]; // 1 from human input = Leden

  return (
    <div>
      {/* <p className="nearest-event-introduction">Nejbližší akce:</p> */}
      <Link to={`akce/${event.year}/${event.month}/${event.day}/${linkName}?`}>
        <p className="nearest-event-header">
          {eventName}
        </p>
        <div className="nearest-event-detail">
          <div className="nearest-event-calendar">
            <div className="nearest-event-month">{renderMonth}</div>
            <div className="nearest-event-day">{event.day}</div>
            <div className="nearest-event-year">{event.year}</div>
          </div>
          <div className="nearest-event-info">
            <p className="nearest-event-info-line">
              <b>{renderDate}</b> {event.weekday ? `(${event.weekday})` : ''}
            </p>
            {event.time ? <p className="nearest-event-info-line">Od {event.time}</p> : null}
            <p className="nearest-event-info-line">
              {renderLocation}
            </p>
          </div>
          <div className="nearest-event-poster">
            {renderPoster}
          </div>
        </div>
      </Link>
    </div>
  );
}

export default NearestEvent;